import styled from "styled-components";
import { colorPalette, typeScale } from "../../../../../../utils/theme";

export const Section = styled.section`
  padding-top: 140px;
  padding-bottom: 80px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 767.98px) {
    padding: 24px 16px;
    padding-bottom: 64px;
  }
`;

export const Stage = styled.div`
  position: relative;
  height: 500px;
  border-radius: 22px;
  background: #ebf1f766;
  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1.51px solid var(--Blue-200, #ebf1f7);
  overflow: visible;
  width: 100%;

  @media (max-width: 767.98px) {
    height: auto;
    padding: 120px 20px 32px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    animation: slideUpMobile 0.8s ease forwards;
    margin-top: 100px;
  }

  @keyframes slideUpMobile {
    from {
      transform: translateY(50px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export const CenterImage = styled.img`
  position: absolute;
  width: 445px;
  height: 350px;
  left: 50%;
  transform: translateX(-50%);
  top: -170px;
  object-fit: cover;
  border-radius: 8px;
  will-change: transform;
  backface-visibility: hidden;
  transform-style: preserve-3d;

  @media (max-width: 767.98px) {
    display: none;
  }
`;

export const CenterImageMobile = styled.img`
  display: none;
  
  @media (max-width: 767.98px) {
    display: block;
    position: absolute;
    width: 100%;
    max-width: 350px;
    height: auto;
    top: -100px;
    left: 50%;
    transform: translateX(-50%);
    object-fit: contain;
    border-radius: 8px;
    will-change: transform;
    backface-visibility: hidden;
    transform-style: preserve-3d;
    z-index: 3;
  }
`;

export const LeftCard = styled.div`
  position: absolute;
  width: 420px;
  background: white;
  border-radius: 16px;
  padding: 24px;
  top: -30px;
  left: 64px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 2;
  will-change: transform;
  backface-visibility: hidden;
  transform-style: preserve-3d;

  @media (max-width: 767.98px) {
    display: none;
  }
`;

export const RightCard = styled.div`
  position: absolute;
  width: 420px;
  background: white;
  border-radius: 16px;
  padding: 24px;
  top: -28px;
  right: 64px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 2;
  will-change: transform;
  backface-visibility: hidden;
  transform-style: preserve-3d;

  @media (max-width: 767.98px) {
    display: none;
  }
`;

export const FloatingBadge = styled.div`
  position: absolute;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 22px;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 500;
  color: #2563eb;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 4;
  white-space: nowrap;
  will-change: transform;
  backface-visibility: hidden;
  transform-style: preserve-3d;

  @media (max-width: 767.98px) {
    display: none;
  }
`;

export const LeftFloatingBadge = styled(FloatingBadge)`
  top: -12px;
  right: -20px;
  border: 1px solid var(--Blue-200, #ebf1f7);
  color: ${colorPalette.textMain};
  ${typeScale.bodySM};
`;

export const RightFloatingBadge = styled(FloatingBadge)`
  bottom: -12px;
  left: -100px;
  border: 1px solid var(--Blue-200, #ebf1f7);
  color: ${colorPalette.textMain};
  ${typeScale.bodySM};
`;

export const BottomFloatingBadge = styled(FloatingBadge)`
  top: 130px;
  left: 450px;
  z-index: 4;
  border: 1px solid var(--Blue-200, #ebf1f7);
  color: ${colorPalette.textMain};
  ${typeScale.bodySM};
`;

export const StageFooter = styled.div`
  position: absolute;
  bottom: 28px;
  text-align: center;
  z-index: 1;

  @media (max-width: 767.98px) {
    position: static;
    transform: none;
    width: 100%;
    max-width: none;
    padding: 0;
    margin-top: 160px;
  }
`;

export const FooterBadge = styled.div`
  margin-bottom: 4px;
  text-transform: uppercase;
  color: ${colorPalette.blue500};
  ${typeScale.bodyXSMain};

  @media (max-width: 767.98px) {
    margin-bottom: 8px;
    ${typeScale.bodyXXSMain};
  }
`;

export const Headline = styled.h2`
  margin-bottom: 16px;
  color: ${colorPalette.textMain};
  ${typeScale.headingXLMain};

  @media (max-width: 767.98px) {
    margin-bottom: 12px;
    ${typeScale.headingSMMain};
  }
`;

export const Subtitle = styled.div`
  margin-bottom: 32px;
  justify-self: center;
  width: 100%;
  color: ${colorPalette.textDark};
  ${typeScale.bodyLG};
  text-align: center;

  // Make 80% width on md breakpoints
  @media (min-width: 992px) {
    width: 70%;
    margin: 0 auto 32px auto;
  }

  @media (max-width: 767.98px) {
    margin-bottom: 16px;
    ${typeScale.bodySM};
    text-align: center;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;

  @media (max-width: 767.98px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const AppButton = styled.button`
  padding: 12px 24px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: white;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #f9fafb;
    transform: translateY(-1px);
  }

  @media (max-width: 767.98px) {
    width: 200px;
  }
`;

export const ChartNumber = styled.p`
  margin-bottom: 4px;
  color: ${colorPalette.textMain};
  ${typeScale.headingMain};
`;

export const ChartLabel = styled.div`
  color: ${colorPalette.textDark};
  ${typeScale.bodyXS};
`;

export const ProgressSection = styled.div`
  margin-bottom: 16px;
`;

export const ProgressTitle = styled.div`
  font-size: 0.75rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 16px;
`;

export const ProgressItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const ProgressLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Avatar = styled.img`
  width: 34px;
  height: 34px;
  border-radius: 8px;
`;

export const ProjectName = styled.div`
  color: ${colorPalette.textMain};
  ${typeScale.bodyXSMain};
`;

export const UnitNumber = styled.div`
  color: ${colorPalette.textDark};
  ${typeScale.bodyXXS};
`;

export const ProgressBarContainer = styled.div`
  flex: 1;
  margin: 0 12px;
`;

export const ProgressBar = styled.div<{ progress: number }>`
  width: 100%;
  height: 4px;
  background: #f3f4f6;
  border-radius: 30px;
  overflow: hidden;

  &::after {
    content: "";
    display: block;
    height: 100%;
    width: ${(props) => props.progress}%;
    background: linear-gradient(90deg, #7fccfa 80%, #276ef1 100%);
    transition: width 0.3s ease;
  }
`;

export const ProgressPercent = styled.div`
  color: ${colorPalette.textMain};
  min-width: 32px;
  text-align: right;
  ${typeScale.headingXXSMain};
`;
